import AcronymReportModal from "components/Modal/AcronymReportModal";
import AnnotatedAcronymReportSelectionModal from "components/Modal/AnnotatedAcronymReportSelectionModal";
import AupAcceptanceModal from "components/Modal/AupAcceptanceModal/AupAcceptanceModal";
import CascadeAssigneeModal from "components/Modal/CascadeAssigneeModal";
import CascadeStatusModal from "components/Modal/CascadeStatusModal";
import ChooseDocumentsModal from "components/Modal/ChooseDocumentsModal";
import ChooseFilesModal from "components/Modal/ChooseFilesModal";
import CompareDocumentsModal from "components/Modal/CompareDocumentsModal";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import DateRangeModal from "components/Modal/DateRangeModal";
import ErrorModal from "components/Modal/ErrorModal";
import ImportFileModal from "components/Modal/ImportFileModal";
import SelectFolderModal from "components/Modal/SelectFolderModal";
import SelectUploadedDocumentsModal from "components/Modal/SelectUploadedDocumentsModal";
import TextFieldModal from "components/Modal/TextFieldModal";
import UploadExternalFilesModal from "components/Modal/UploadExternalFilesModal";
import UploadFilesModal from "components/Modal/UploadFilesModal";
import AboutVtDocsModal from "layout/dashboard/modals/AboutVtDocsModal";
import ChangePasswordModal from "layout/dashboard/modals/ChangePasswordModal";
import AnnotatedDocumentModal from "layout/dictionarySearch/modals/AnnotatedDocumentModal";
import ChangeDictionaryModal from "layout/dictionarySearch/modals/ChangeDictionaryModal";
import ExportContentModalXlsx from "layout/dictionarySearch/modals/ExportContentModalXlsx";
import DictionarySearchExportMultipleDocumentsModal from "layout/dictionarySearch/modals/ExportMultipleDocumentsModal";
import ImportDictionaryModal from "layout/dictionarySearch/modals/ImportDictionaryModal";
import CreateNewCategoryModal from "layout/discovery/modals/CreateNewCategoryModal";
import CreateNewDictionaryModal from "layout/discovery/modals/CreateNewDictionaryModal";
import DiscoveryExportMultipleDocumentsModal from "layout/discovery/modals/ExportMultipleDocumentsModal";
import IgnoreTermConfirm from "layout/discovery/modals/IgnoreTermConfirm";
import SaveSnapshotModal from "layout/discovery/modals/SaveSnapshotModal";
import SelectDocumentModal from "layout/discovery/modals/SelectDocumentModal";
import ShredToExcelModal from "layout/discovery/modals/ShredToExcelModal";
import DocumentReadabilityReportOptionsModal from "layout/documentReadabilityReport/DocumentReadabilityReportOptionsModal";
import ChooseShredDocumentModal from "layout/documentShredding/modals/ChooseShredDocumentModal";
import ShredAnnotatedDocumentModal from "layout/documentShredding/modals/ShredAnnotatedDocumentModal";
import LastUpdatedCustomRangeModal from "layout/opportunities/ViewModes/LastUpdatedCustomRangeModal";
import ImportPromptLibraryCsvModal from "layout/prompts/components/ImportPromptLibraryCsvModal";
import { DeleteOutlineSectionsModal } from "layout/proposals/outline";
import OutlineClarificationModal from "layout/proposals/outline/OutlineClarificationModal";
import ResetDefaultsModal from "layout/settings/readabilityThresholds/ResetDefaultsModal";
import EnableSsoModal from "layout/systemAdmin/authentication/modals/EnableSsoModal";
import EnableUserPasswordModal from "layout/systemAdmin/authentication/modals/EnableUsernamePasswordModal";
import DisableAiFeatureModal from "layout/systemAdmin/GenerativeAI/modals/DisableAiFeatureModal";
import editUserModal from "layout/systemAdmin/users/modals/EditUserModal";
import ImportUsersModal from "layout/systemAdmin/users/modals/ImportUsersModal";
import newUserModal from "layout/systemAdmin/users/modals/NewUserModal";
import AddUserModal from "layout/systemAdmin/workspaces/modals/AddUserModal";
import AnonymiseUsersModal from "layout/systemAdmin/workspaces/modals/AnonymiseUsersModal";
import BannerModal from "layout/systemAdmin/workspaces/modals/BannerModal";
import CreateWorkspaceWithLicensingModal from "layout/systemAdmin/workspaces/modals/CreateWorkspaceWithLicensingModal";
import DeleteWorkspaceModal from "layout/systemAdmin/workspaces/modals/DeleteWorkspaceModal";
import EditLicensingModal from "layout/systemAdmin/workspaces/modals/EditLicensingModal";
import EditUserPermissionsModal from "layout/systemAdmin/workspaces/modals/EditUserPermissionsModal";
import ExportReportModal from "layout/systemAdmin/workspaces/modals/ExportReportModal";
import PasswordExpiryModal from "layout/systemAdmin/workspaces/modals/PasswordExpiryModal";
import ReserveLicensesModal from "layout/systemAdmin/workspaces/modals/ReserveLicensesModal";
import EditUserAndPermissionsModal from "layout/userAdmin/users/modals/EditUserAndPermissionsModal";
import * as PropTypes from "prop-types";
import { useEffect } from "react";

import AddInConfirmOutlineInsert from "./AddInConfirmOutlineInsert";
import AddInNameClashPrompt from "./AddInNameClashPrompt";
import AddInTurnOffAutosave from "./AddInTurnOffAutosave/AddInTurnOffAutosave";
import ArchivedOpportunitiesByReasonModal from "./ArchivedOpportunitiesByReasonModal";
import ArchiveEntityModal from "./ArchiveEntityModal";
import ArchiveStatusReassignModal from "./ArchiveStatusReassignModal";
import CancelAnalysisModal from "./CancelAnalysisModal";
import CollectionReindexProgressModal from "./CollectionReindexProgressModal";
import CollectionsModal from "./CollectionsModal/CollectionsModal";
import CombineOutlineDocsModal from "./CombineOutlineDocsModal";
import ConfirmDocStyleTemplateModal from "./ConfirmDocStyleTemplateModal";
import DeleteOutlineModal from "./DeleteOutlineModal";
import DetachDocumentModal from "./DetachDocumentModal";
import DocumentStaleReloadModal from "./DocumentStaleReloadModal";
import DocumentSyncModal from "./DocumentSyncModal";
import GatePreviewModal from "./GatePreviewModal";
import GenericDeleteModal from "./GenericDeleteModal";
import HasUnsavedChangesModal from "./HasUnsavedChangesModal";
import HeadingSyncModal, { HeadingDeleteModal } from "./HeadingSyncModal";
import KanbanAddStageGateQuestion from "./KanbanAddStageGateQuestion";
import KanbanGateMoveModal from "./KanbanGateMoveModal";
import LoadingModal from "./LoadingModal";
import LockedItemsModal from "./LockedItemsModal";
import NewOpportunityChooserModal from "./NewOpportunityChooserModal";
import NewProposalChooserModal from "./NewProposalChooserModal";
import OpportunityToProposalModal from "./OpportunityToProposalModal";
import PipelineByOwnerModal from "./PipelineByOwnerModal";
import PipelineFunnelModal from "./PipelineFunnelModal";
import PipelineValueByCustomerModal from "./PipelineValueByCustomerModal";
import ProposalAssignmentModal from "./ProposalAssignmentModal";
import ProposalSectionsAssignmentModal from "./ProposalSectionsAssignmentModal";
import RecalcProgressModal from "./RecalcProgressModal";
import ScoringSwapWatchwordsListModal from "./ScoringSwapWatchwordsListModal";
import SectionStatusModal from "./SectionStatusModal";
import SessionTimeoutWarningModal from "./SessionTimeoutWarningModal";
import StartWritingProposalOutlineWizard from "./StartWritingProposalOutlineWizard";
import TimeInStageModal from "./TimeInStageModal";
import TotalPipelineModal from "./TotalPipelineModal";
import TrackedOpportunityPickerModal from "./TrackedOpportunityPickerModal";
import UnarchiveProposalModal from "./UnarchiveProposalModal";

const MODAL_COMPONENTS = {
  AUP_ACCEPTANCE: AupAcceptanceModal,
  SAVE_SNAPSHOT: SaveSnapshotModal,
  CONFIRMATION: ConfirmationModal,
  ADD_USER_TO_WORKSPACE: AddUserModal,
  ERROR: ErrorModal,
  DELETE_WORKSPACE: DeleteWorkspaceModal,
  WORKSPACE_RESERVED_LICENSES: ReserveLicensesModal,
  ANONYMIZE_USERS: AnonymiseUsersModal,
  WORKSPACE_BANNER: BannerModal,
  EDIT_PERMISSIONS: EditUserPermissionsModal,
  EXPORT_REPORT: ExportReportModal,
  NEW_USER: newUserModal,
  EDIT_USER: editUserModal,
  IMPORT_USERS: ImportUsersModal,
  EDIT_USER_AND_PERMISSIONS: EditUserAndPermissionsModal,
  ENABLE_SSO: EnableSsoModal,
  ENABLE_USERNAME_PASSWORD: EnableUserPasswordModal,
  ABOUT_VT_DOCS: AboutVtDocsModal,
  CHANGE_PASSWORD: ChangePasswordModal,
  IMPORT_FILE: ImportFileModal,
  TEXT_FIELD_MODAL: TextFieldModal,
  CHANGE_DICTIONARY: ChangeDictionaryModal,
  EXPORT_MULTIPLE_DOCS: DictionarySearchExportMultipleDocumentsModal,
  EXPORT_CONTENT: ExportContentModalXlsx,
  IMPORT_DICTIONARY: ImportDictionaryModal,
  ANNOTATED_DOCUMENT: AnnotatedDocumentModal,
  SHRED_ANNOTATED_DOCUMENT: ShredAnnotatedDocumentModal,
  CHOOSE_SHRED_DOCUMENT: ChooseShredDocumentModal,
  SHRED_TO_EXCEL: ShredToExcelModal,
  DISCOVERY_EXPORT_MULTIPLE_DOCS: DiscoveryExportMultipleDocumentsModal,
  RESET_DEFAULTS_THRESHOLDS: ResetDefaultsModal,
  IGNORE_TERM_CONFIRM: IgnoreTermConfirm,
  CREATE_NEW_DICTIONARY: CreateNewDictionaryModal,
  UPLOAD_FILES: UploadFilesModal,
  UPLOAD_EXTERNAL_FILES: UploadExternalFilesModal,
  SELECT_FOLDER: SelectFolderModal,
  COMPARE_DOCUMENTS: CompareDocumentsModal,
  CHOOSE_DOCUMENTS: ChooseDocumentsModal,
  ACRONYM_REPORT: AcronymReportModal,
  DATE_RANGE: DateRangeModal,
  EDIT_LICENSING: EditLicensingModal,
  PASSWORD_EXPIRY: PasswordExpiryModal,
  CREATE_WORKSPACE_WITH_LICENSING: CreateWorkspaceWithLicensingModal,
  CREATE_NEW_CATEGORY: CreateNewCategoryModal,
  SELECT_DOCUMENT: SelectDocumentModal,
  DOCUMENT_READABILITY_REPORT_OPTIONS: DocumentReadabilityReportOptionsModal,
  HAS_UNSAVED_CHANGES: HasUnsavedChangesModal,
  DOCUMENT_STALE_RELOAD: DocumentStaleReloadModal,
  CHOOSE_FILES: ChooseFilesModal,
  GENERIC_DELETE_MODAL: GenericDeleteModal,
  CANCEL_ANALYSIS_MODAL: CancelAnalysisModal,
  SELECT_UPLOADED_DOCUMENTS: SelectUploadedDocumentsModal,
  ANNOTATED_ACRONYM_REPORT_SELECTION: AnnotatedAcronymReportSelectionModal,
  LOADING_MODAL: LoadingModal,
  COLLECTIONS_MODAL: CollectionsModal,
  LAST_UPDATED_CUSTOM_RANGE: LastUpdatedCustomRangeModal,
  HEADING_SYNC_MODAL: HeadingSyncModal,
  START_WRITING_PROPOSAL_OUTLINE_WIZARD: StartWritingProposalOutlineWizard,
  HEADING_DELETE_MODAL: HeadingDeleteModal,
  DETACH_DOCUMENT_MODAL: DetachDocumentModal,
  DOCUMENT_SYNC_PROGRESS: DocumentSyncModal,
  COLLECTION_REINDEX_PROGRESS: CollectionReindexProgressModal,
  ARCHIVE_ENTITY_MODAL: ArchiveEntityModal,
  UNARCHIVE_PROPOSAL: UnarchiveProposalModal,
  ARCHIVE_STATUS_REASSIGN_MODAL: ArchiveStatusReassignModal,
  IMPORT_PROMPT_LIBRARY_CSV: ImportPromptLibraryCsvModal,
  SCORING_SWAP_WATCHWORDS_LIST: ScoringSwapWatchwordsListModal,
  ADD_IN_CONFIRM_OUTLINE_INSERT: AddInConfirmOutlineInsert,
  ADD_IN_NAME_CLASH_PROMPT: AddInNameClashPrompt,
  ADD_IN_TURN_OFF_AUTOSAVE: AddInTurnOffAutosave,
  SESSION_TIMEOUT_WARNING: SessionTimeoutWarningModal,
  NEW_OPPORTUNITY_CHOOSER: NewOpportunityChooserModal,
  NEW_PROPOSAL_CHOOSER: NewProposalChooserModal,
  PIPELINE_BY_OWNER: PipelineByOwnerModal,
  PIPELINE_FUNNEL: PipelineFunnelModal,
  PIPELINE_VALUE_BY_CUSTOMER: PipelineValueByCustomerModal,
  SECTION_STATUS: SectionStatusModal,
  TIME_IN_STAGE: TimeInStageModal,
  TOTAL_PIPELINE: TotalPipelineModal,
  TRACKED_OPPORTUNITY_PICKER: TrackedOpportunityPickerModal,
  RECALC_PROGRESS: RecalcProgressModal,
  CLARIFICATION_REQUIRED: OutlineClarificationModal,
  LOCKED_ITEMS_MODAL: LockedItemsModal,
  CONFIRM_DOC_STYLE_TEMPLATE_MODAL: ConfirmDocStyleTemplateModal,
  KANBAN_ADD_STAGE_GATE_QUESTION: KanbanAddStageGateQuestion,
  KANBAN_GATE_MOVE_MODAL: KanbanGateMoveModal,
  GATE_PREVIEW_MODAL: GatePreviewModal,
  DELETE_OUTLINE_SECTIONS_MODAL: DeleteOutlineSectionsModal,
  DELETE_OUTLINE_MODAL: DeleteOutlineModal,
  COMBINE_OUTLINE_DOCS_MODAL: CombineOutlineDocsModal,
  CASCADE_ASSIGNEE_MODAL: CascadeAssigneeModal,
  CASCADE_STATUS_MODAL: CascadeStatusModal,
  OPPORTUNITY_TO_PROPOSAL: OpportunityToProposalModal,
  ARCHIVED_OPPORTUNITIES_BY_REASON: ArchivedOpportunitiesByReasonModal,
  PROPOSAL_ASSIGNMENT: ProposalAssignmentModal,
  PROPOSAL_SECTIONS_ASSIGNMENT: ProposalSectionsAssignmentModal,
  DISABLE_AI_FEATURE_MODAL: DisableAiFeatureModal,
};

const ModalRoot = ({ modalType, modalProps }) => {
  useEffect(() => {
    if (modalType) {
      const dialog = document.querySelector("[role='dialog']");
      if (dialog && !dialog.contains(document.activeElement)) {
        dialog.focus();
      }
    }
  }, [modalType]);

  if (!modalType || !MODAL_COMPONENTS[modalType]) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  // The modalProps can be a list of anything so this has to be spread
  return <SpecificModal {...modalProps} />;
};

export default ModalRoot;

ModalRoot.propTypes = {
  modalType: PropTypes.string,
  // The modalProps can be a list of anything so this has to be an object with not types

  modalProps: PropTypes.object,
};
